import { __assign } from "tslib";
import { registerShape } from '@antv/g2';
registerShape('polygon', 'heatmap-circle-size', {
    draw: function (cfg, group) {
        var cx = cfg.x;
        var cy = cfg.y;
        var points = this.parsePoints(cfg.points);
        var width = Math.abs(points[2].x - points[1].x);
        var height = Math.abs(points[1].y - points[0].y);
        var maxRadius = Math.min(width, height) / 2;
        var value = Number(cfg.shape[1]);
        var sizeRatio = Number(cfg.shape[2]);
        var radiusRatio = Math.sqrt(sizeRatio);
        var radius = maxRadius * radiusRatio * Math.sqrt(value);
        var polygon = group.addShape('circle', {
            attrs: __assign({ x: cx, y: cy, r: radius, fill: cfg.color }, cfg.defaultStyle),
        });
        return polygon;
    },
});
//# sourceMappingURL=circle.js.map